var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-template"},[_vm._v("这是demo页面的模板")])}
var staticRenderFns = []

export { render, staticRenderFns }